
export const sFechaPublicacion = '2026-08-25T17:59:54.5810993-06:00';
export const sVersion = 'vf1.1.608251759';
            